/* eslint-disable consistent-return */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useHistory } from 'react-router-dom';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { Button } from 'react-bootstrap';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { useDispatch, useSelector } from 'react-redux';
import SVGComponent from '../../../../../../SharedModules/SVGComponents/SVGComponents';
import {
  getRebateProgramCode,
  setCms64Data,
  getMaxQuarterForRebatePrg,
  listCmsReportGroups,
  getRebateProgramByCMSReportGrp,
  setErrorMessagesData,
  getReportQuarter,
  getPreviousQtr,
  dispatchRebateProgByCMSReportGrp,
  setCMSReportingGrps,
} from '../../ReqInitCorrectCmsReport/Store/actions';
import {
  REBATE_PROGRAM_REQUIRED,
  QUARTER_VALUE_REQUIRED,
  VALIDATE_QUARTER_VALUE,
  REBATE_REPORTING_REQUIRED,
} from '../../../../../../SharedModules/Errors/constantMessageData';
import { getUserDefaults } from '../../../../UserDefault/store/actions';
import {
  quarterTest1,
  quarterTest2,
  checkQuarterValidation,
} from '../../../../../../SharedModules/CommonUtilities/commonUtilities';
import GroupOfRebateProgramComponent from '../../../../../../SharedModules/CustomGroupOfRebateProgram/GroupOfRebateProgramComponent';
import { autoFormateDate } from '../../../../../../SharedModules/utilities/utilities';

let abortController = new AbortController();

const ResearchExistingCMS64ReportHeader = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [palType, setPalType] = useState(null);

  const createCms64Data = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer?.createCms64Data
  );
  const rebateProgramCode = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer?.rebateProgramCode?.data
  );

  const quarter = useSelector(
    (state) =>
      state.sharedState.CreateCmsReportReducer?.createCms64Data?.quarter
  );

  const createCmsReport = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer.createCmsReport
  );

  const defaultQtr = useSelector(
    (state) =>
      state.sharedState.CreateUtilizationTapeReducer?.defaultQtrCUF?.data
  );
  const cmsReportingGrps = useSelector(
    (state) =>
      state.sharedState.CreateUtilizationTapeReducer?.cmsReportingGrps?.data
  );
  const rebatePrgByCMS = useSelector(
    (state) =>
      state.sharedState.CreateUtilizationTapeReducer?.rebatePrgByCMS?.data
  );
  const errorMessagesData = useSelector(
    (state) => state.sharedState.CreateUtilizationTapeReducer.errorMessages
  );

  const userDefault = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const defaultRebateProgramCd = useSelector(
    (state) =>
      state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
        ?.rebateProgramCd
  );
  const navigateToPage = (pathName, value) => {
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (updateTabs.findIndex((item) => item.navTo === pathName) === -1) {
      updateTabs.push({
        navTo: pathName,
        value: value,
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }

    history.push({
      pathname: pathName,
    });
  };
  const getUserDefaultValues = (value) => dispatch(getUserDefaults(value));
  const getCmsReportGroups = (value) => dispatch(listCmsReportGroups(value));

  const getRebateProgramCodeValue = (values, signal) => {
    dispatch(getRebateProgramCode(values, signal));
  };

  useEffect(() => {
    let rbtPrgSelObj = [];
    if (defaultRebateProgramCd) {
      rbtPrgSelObj = rebateProgramCode?.filter(
        (x) => x.rebateProgramCd == defaultRebateProgramCd
      );
    }
    dispatch(
      setCms64Data({
        ...createCms64Data,
        rebateProgramSelObj: rbtPrgSelObj,
      })
    );
  }, [rebateProgramCode]);
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  useEffect(() => {
    getUserDefaultValues(logInUser);
    if (defaultRebateProgramCd !== '' && defaultRebateProgramCd) {
      dispatch(
        getMaxQuarterForRebatePrg({
          rebateProgramCd: defaultRebateProgramCd,
        })
      );
    }
    dispatch(
      setCms64Data({
        ...createCms64Data,
        quarter: createCms64Data?.quarter || defaultQtr,
        planType: 'FD',
        cmsReportingGrps: createCms64Data?.cmsReportingGrps || '-1',
        rebateProgramCd:
          createCms64Data?.rebateProgramCd || defaultRebateProgramCd,
        selectBy: createCms64Data.selectBy || 'single',
      })
    );
    if (
      createCms64Data?.quarter &&
      checkQuarterValidation(createCms64Data?.quarter)
    ) {
      fetchGroupOfRebateProgramList(createCms64Data?.quarter);
    }
  }, []);

  const fetchAllRebateProgramWithGroup = (val) => {
    if (val) {
      dispatch(
        getRebateProgramByCMSReportGrp({
          quarter: createCms64Data?.quarter,
          rebateProgramCode: val,
        })
      );
    }
  };
  useEffect(() => {
    if (createCms64Data.quarter) {
      getCmsReportGroups(createCms64Data.quarter);
    }
  }, [createCms64Data?.quarter]);

  useEffect(() => {
    if (defaultQtr) {
      dispatch(
        setCms64Data({
          ...createCms64Data,
          quarter: createCms64Data?.quarter || defaultQtr,
        })
      );
    }
  }, [defaultQtr]);

  useEffect(() => {
    if (userDefault) {
      if (userDefault.planTypeCd) {
        setPalType(userDefault.planTypeCd);
      } else {
        setPalType('FD');
      }
    }
  }, [userDefault]);

  useEffect(() => {
    if (palType) {
      abortController = new AbortController();
      getRebateProgramCodeValue(palType, abortController.signal);
    }
    // Cleanup function to abort the old request on unmount or when date changes
    return () => {
      abortController.abort();
    };
  }, [palType]);

  useEffect(() => {
    if (
      rebateProgramCode &&
      rebateProgramCode.length > 0 &&
      defaultRebateProgramCd
    ) {
      const filterArr = rebateProgramCode.filter(
        (item) => item.value === defaultRebateProgramCd
      );

      if (filterArr.length > 0) {
        dispatch(
          setCms64Data({
            ...createCms64Data,
            rebateProgramCd: filterArr[0].value,
          })
        );
      }
    }
  }, [rebateProgramCode, defaultRebateProgramCd]);
  const fetchGroupOfRebateProgramList = (val) => {
    if (checkQuarterValidation(val)) {
      getCmsReportGroups(val);
    }
  };

  useEffect(() => {
    if (createCms64Data?.planType) {
      setPalType(createCms64Data?.planType);
    }
  }, [createCms64Data?.planType]);
  useEffect(() => {
    if (createCmsReport && typeof createCmsReport === 'string') {
      return setConfirmModal(createCmsReport);
    }
  }, [createCmsReport]);
  const handleCreateUtilTapeData = (e) => {
    if(e.target.name === 'selectBy'){
      dispatch(setErrorMessagesData([]))
    }
    dispatch(
      setCms64Data({
        ...createCms64Data,
        [e.target.name]: e.target.value,
        ...('planType' in createCms64Data &&
          e.target.name === 'planType' && { rebateProgramCd: '-1' }),
      })
    );
  };
  const handleOnblurEvent = (type, value) => {
    let localErr = errorMessagesData || [];
    const data = value;
    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateProgramCd',
          message: REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      }
    }
    if (type === 'cmsReportingGrps') {
      if (!value || value === '-1') {
        localErr = localErr?.filter(
          (item) => item.field !== 'cmsReportingGrps'
        );
        localErr.push({
          field: 'cmsReportingGrps',
          errorType: 'cmsReportingGrps',
          message: REBATE_REPORTING_REQUIRED,
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'cmsReportingGrps');
      }
    }
    if (type === 'quarter') {
      if (data && !_.isEmpty(data) && !_.isNaN(data)) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'quarter',
              errorType: 'required',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        if (quarterTest1.test(data) || quarterTest2.test(data)) {
          const indexOf = !_.isEmpty(localErr)
            ? _.findIndex(localErr, {
                field: 'quarter',
                errorType: 'invalidFormat',
              })
            : null;

          if (!_.isNull(indexOf) && indexOf >= 0) {
            localErr.splice(indexOf, 1);
          }
          localErr = localErr.filter((item) => item.field !== 'quarter');
          dispatch(
            setCms64Data({
              ...createCms64Data,
              [type]: value,
            })
          );
        } else {
          localErr = localErr.filter((item) => item.field !== 'quarter');
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: VALIDATE_QUARTER_VALUE,
          });
        }
      } else {
        localErr = localErr.filter((item) => item.field !== 'quarter');
        if (type === 'quarter') {
          localErr.push({
            field: 'quarter',
            errorType: 'required',
            message: QUARTER_VALUE_REQUIRED,
          });
        }
      }
    }

    const unique = [...new Set(localErr)];
    dispatch(setErrorMessagesData(unique));
    dispatch(
      setCms64Data({
        ...createCms64Data,
        [type]: value,
      })
    );
  };
  const validateCreateCmsReq = () => {
    let localErr = [];
    if (createCms64Data?.selectBy === 'single') {
      if (
        !createCms64Data?.rebateProgramCd ||
        createCms64Data?.rebateProgramCd === '-1'
      ) {
        localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateProgramCd',
          message: REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'rebateProgramCd');
      }
    }
    if (createCms64Data?.selectBy === 'group') {
      if (
        createCms64Data?.cmsReportingGrps === '-1' ||
        !createCms64Data?.cmsReportingGrps
      ) {
        localErr.push({
          field: 'cmsReportingGrps',
          errorType: 'cmsReportingGrps',
          message: REBATE_REPORTING_REQUIRED,
        });
      } else {
        localErr = localErr.filter((item) => item.field !== 'cmsReportingGrps');
      }
    }
    if (
      createCms64Data?.quarter &&
      !_.isEmpty(createCms64Data?.quarter) &&
      !_.isNaN(createCms64Data?.quarter)
    ) {
      const indexOf = !_.isEmpty(localErr)
        ? _.findIndex(localErr, {
            field: 'quarter',
            errorType: 'required',
          })
        : null;

      if (!_.isNull(indexOf) && indexOf >= 0) {
        localErr.splice(indexOf, 1);
      }
      if (
        quarterTest1.test(createCms64Data?.quarter) ||
        quarterTest2.test(createCms64Data?.quarter)
      ) {
        const indexOf = !_.isEmpty(localErr)
          ? _.findIndex(localErr, {
              field: 'quarter',
              errorType: 'invalidFormat',
            })
          : null;

        if (!_.isNull(indexOf) && indexOf >= 0) {
          localErr.splice(indexOf, 1);
        }
        localErr = localErr.filter((item) => item.field !== 'quarter');
      } else {
        localErr = localErr.filter((item) => item.field !== 'quarter');
        localErr.push({
          field: 'quarter',
          errorType: 'invalidFormat',
          message: VALIDATE_QUARTER_VALUE,
        });
      }
    } else {
      localErr = localErr.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'required',
        message: QUARTER_VALUE_REQUIRED,
      });
    }
    const unique = [...new Set(localErr)];
    dispatch(setErrorMessagesData(unique));
    if (localErr.length > 0) {
      return false;
    }
    return true;
  };

  const runProcess = async (invoiceStartFlag = false, qtrFlag = false) => {
    if (validateCreateCmsReq()) {
      const str = rebatePrgByCMS?.map((item) => {
        return item.rebateProgramCode;
      });
      const reqInvoiceCalcDataPayload2 = {
        rpc:
          createCms64Data?.selectBy === 'group'
            ? str
            : [createCms64Data?.rebateProgramCd],
        rptQtr: createCms64Data?.quarter,
        codeDomainKey: 'STATE_CD',
        invoiceStartFlag: invoiceStartFlag,
        qtrFlag: qtrFlag,
        cmsFlag: true,
      };

      await dispatch(getReportQuarter(reqInvoiceCalcDataPayload2));
      await dispatch(
        getPreviousQtr(createCms64Data.quarter ? createCms64Data.quarter : '')
      );

      navigateToPage(
        '/researchexisitngcms64reportdetails',
        'Research Existing CMS64 Rpt'
      );
    }
  };
  // fullscreen functionality
  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  return (
    <>
      {!fullScreenView && (
        <div className="panel mb-3">
          <div className="row">
            <div className="col-sm-8">
              <fieldset className="custom-fieldset">
                <legend
                  className="same-font-family"
                  id="demo-row-radio-buttons-group-select-by-label"
                >
                  Select by
                </legend>
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div className="sub-radio no-margin">
                      <FormControl>
                        <RadioGroup
                          row
                          aria-labelledby="demo-row-radio-buttons-group-select-by-label"
                          name="selectBy"
                          onChange={handleCreateUtilTapeData}
                          value={createCms64Data?.selectBy || 'single'}
                          required
                        >
                          <FormControlLabel
                            style={{ marginRight: '170px' }}
                            value="single"
                            control={<Radio />}
                            label="Single Rebate Program"
                            data-test="singleRbtPrg"
                          />
                          <FormControlLabel
                            value="group"
                            control={<Radio />}
                            label="Group of Rebate Programs"
                            data-test="grpRbtPrg"
                          />
                        </RadioGroup>
                      </FormControl>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>

            <div className="col-sm-4 mt-2">
              <fieldset className="custom-fieldset">
                {/* <legend className='same-font-family'></legend> */}
                <div className="form-wrapper p-0 mt-2">
                  <div className="mui-custom-form input-md field-xl">
                    <div>
                      <TextField
                        label="Quarter"
                        id="quarter"
                        fullWidth
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 6, id: 'quarter' }}
                        required
                        name="quarter"
                        value={createCms64Data?.quarter}
                        onChange={handleCreateUtilTapeData}
                        onBlur={(e) => {
                          handleOnblurEvent(
                            'quarter',
                            autoFormateDate(e?.target?.value?.toUpperCase())
                          );
                          fetchGroupOfRebateProgramList(e?.target?.value);
                          dispatch(
                            setCms64Data({
                              ...createCms64Data,
                              quarter: autoFormateDate(
                                e?.target?.value?.toUpperCase()
                              ),
                              cmsReportingGrps: '-1',
                            })
                          );
                          dispatch(dispatchRebateProgByCMSReportGrp([]));
                          dispatch(setCMSReportingGrps([]));
                        }}
                        className={
                          errorMessagesData?.length > 0
                            ? _.map(errorMessagesData, (l) =>
                                l.field === 'quarter' ? 'mandate-fields' : null
                              )
                            : null
                        }
                        helperText={
                          errorMessagesData?.length > 0
                            ? _.map(errorMessagesData, (l) =>
                                l.field === 'quarter' ? l.message : null
                              )
                            : null
                        }
                        error={
                          errorMessagesData?.length > 0
                            ? _.map(errorMessagesData, (l) =>
                                l.field == 'quarter' ? l.message : null
                              )
                            : null
                        }
                      />
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </div>
          <div className="row">
            {createCms64Data?.selectBy === 'single' ? (
              <>
                <div className="col-sm-8">
                  <fieldset className="custom-fieldset">
                    <legend
                      className="same-font-family"
                      id="demo-row-radio-buttons-group-plan-type-label"
                    >
                      Plan Type
                    </legend>
                    <div className="form-wrapper p-0 mt-2">
                      <div className="mui-custom-form input-md field-xl">
                        <div className="sub-radio no-margin">
                          <FormControl>
                            <RadioGroup
                              row
                              aria-labelledby="demo-row-radio-buttons-group-plan-type-label"
                              name="planType"
                              onChange={handleCreateUtilTapeData}
                              value={palType}
                              required
                            >
                              <FormControlLabel
                                style={{ marginRight: '65px' }}
                                value="FD"
                                control={<Radio />}
                                label="Medicaid"
                                data-test="Medicaid"
                              />
                              <FormControlLabel
                                style={{ marginRight: '65px' }}
                                value="COMM"
                                control={<Radio />}
                                label="Commercial"
                                data-test="Commercial"
                              />
                              <FormControlLabel
                                style={{ marginRight: '65px' }}
                                value="ST"
                                control={<Radio />}
                                label="State"
                                data-test="State"
                              />
                              <FormControlLabel
                                value="SUPP"
                                control={<Radio />}
                                label="Supplemental"
                                data-test="Supplemental"
                              />
                            </RadioGroup>
                          </FormControl>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>

                <div className="col-sm-4 mt-2">
                  <fieldset className="custom-fieldset">
                    <div className="form-wrapper p-0 mt-2">
                      <div className="mui-custom-form input-md field-xl">
                        <div>
                          <TextField
                            label="Rebate Program"
                            id="rebateProgramCd"
                            fullWidth
                            select
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{ id: 'rebateProgramCd' }}
                            required
                            onChange={handleCreateUtilTapeData}
                            name="rebateProgramCd"
                            value={createCms64Data?.rebateProgramCd || '-1'}
                            className={
                              errorMessagesData?.length > 0
                                ? _.map(errorMessagesData, (l) =>
                                    l.field === 'rebateProgramCd'
                                      ? 'mandate-fields'
                                      : null
                                  )
                                : null
                            }
                            onBlur={(e) =>
                              handleOnblurEvent(
                                'rebateProgramCd',
                                e?.target?.value
                              )
                            }
                            error={
                              errorMessagesData?.length > 0
                                ? _.map(errorMessagesData, (l) =>
                                    l.field === 'rebateProgramCd'
                                      ? l.message
                                      : null
                                  )
                                : null
                            }
                            helperText={
                              errorMessagesData?.length > 0
                                ? _.map(errorMessagesData, (l) =>
                                    l.field === 'rebateProgramCd'
                                      ? l.message
                                      : null
                                  )
                                : null
                            }
                          >
                            <MenuItem
                              key=""
                              value="-1"
                              className="frr-dropdown-blank-item"
                            />
                            {rebateProgramCode?.length > 0
                              ? rebateProgramCode.map((item) => {
                                  return (
                                    <MenuItem
                                      key={item.rebateProgramCd}
                                      value={item.rebateProgramCd}
                                    >
                                      {item.rebateProgramCd} {'|'}{' '}
                                      {item.shortDescr}
                                    </MenuItem>
                                  );
                                })
                              : null}
                          </TextField>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
              </>
            ) : null}

            {createCms64Data?.selectBy === 'group' ? (
              <>
                <div className="col-8 mt-2">
                  <fieldset className="custom-fieldset">
                    {/* <legend className='same-font-family'></legend> */}
                    <div className="form-wrapper p-0 mt-2">
                      <div className="mui-custom-form input-md field-xl">
                        <div>
                          <TextField
                            id="cmsReportingGrps"
                            label="CMS Reporting Group"
                            fullWidth
                            select
                            placeholder=""
                            InputLabelProps={{
                              shrink: true,
                            }}
                            inputProps={{
                              id: 'cmsReportingGrps',
                            }}
                            required
                            onChange={(e) => {
                              fetchAllRebateProgramWithGroup(e.target?.value);
                              handleCreateUtilTapeData(e);
                            }}
                            name="cmsReportingGrps"
                            value={createCms64Data?.cmsReportingGrps || '-1'}
                            onBlur={(e) => {
                              let localErr = errorMessagesData || [];
                              if (!e.target.value || e.target.value === '-1') {
                                localErr = localErr?.filter(
                                  (item) => item.field !== 'cmsReportingGrps'
                                );
                                localErr.push({
                                  field: 'cmsReportingGrps',
                                  errorType: 'cmsReportingGrps',
                                  message: REBATE_REPORTING_REQUIRED,
                                });
                              } else {
                                localErr = localErr.filter(
                                  (item) => item.field !== 'cmsReportingGrps'
                                );
                              }
                              const unique = [...new Set(localErr)];
                              dispatch(setErrorMessagesData(unique));
                            }}
                            className={
                              errorMessagesData?.length > 0
                                ? _.map(errorMessagesData, (l) =>
                                    l.field == 'cmsReportingGrps'
                                      ? 'mandate-fields'
                                      : null
                                  )
                                : null
                            }
                            error={
                              errorMessagesData?.length > 0
                                ? _.map(errorMessagesData, (l) =>
                                    l.field === 'cmsReportingGrps'
                                      ? l.message
                                      : null
                                  )
                                : null
                            }
                            helperText={
                              errorMessagesData?.length > 0
                                ? _.map(errorMessagesData, (l) =>
                                    l.field === 'cmsReportingGrps'
                                      ? l.message
                                      : null
                                  )
                                : null
                            }
                          >
                            <MenuItem
                              key=""
                              value="-1"
                              className="frr-dropdown-blank-item"
                            />
                            {cmsReportingGrps &&
                            cmsReportingGrps.length &&
                            cmsReportingGrps.length > 0
                              ? cmsReportingGrps.map((item) => {
                                  return (
                                    <MenuItem key={item} value={item}>
                                      {item}
                                    </MenuItem>
                                  );
                                })
                              : null}
                          </TextField>
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </div>
                <div className="col-4 btn-wrapper mt-4">
                  <div className="float-right hide-on-print">
                    <Button
                      className="btn-success same-font-family frr-btn-width-17 mt-4"
                      onClick={() => {
                        runProcess();
                      }}
                    >
                      <SVGComponent iconName="Create-new-icon" /> Process
                    </Button>
                  </div>
                </div>
              </>
            ) : null}
          </div>
          {createCms64Data?.selectBy === 'single' && (
            <div className="row float-right">
              <div className="btn-wrapper mb-2">
                <div className="mt-1 ml-4 hide-on-print">
                  <Button
                    className="btn-success same-font-family frr-btn-width-17 mt-4"
                    onClick={() => {
                      runProcess();
                    }}
                  >
                    <SVGComponent iconName="Create-new-icon" /> Process
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
      {createCms64Data?.selectBy === 'group' && (
        <div className="panel-body FRR-custom-table tbl-manufacturer-inner frr-log_chk">
          <GroupOfRebateProgramComponent
            fullScreenView={fullScreenView}
            handleFullScreenView={handleFullScreenView}
            data={
              createCms64Data?.cmsReportingGrps !== '' &&
              createCms64Data?.cmsReportingGrps !== '-1'
                ? rebatePrgByCMS?.map((item) => {
                    item.rebateProgramCd = item.rebateProgramCode;
                    item.shortDescr = item.shortDesc;
                    return item;
                  })
                : []
            }
            fileName="G-Rebate Program Grid"
          />
        </div>
      )}{' '}
    </>
  );
};
export default ResearchExistingCMS64ReportHeader;
